var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadDetail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15361",
    "data-name": "Trazado 15361",
    d: "M167.5,9.25h-1.672l-1.5,1.5H167.5a.5.5,0,0,1,.5.5v2.5a.5.5,0,0,1-.5.5h-12a.5.5,0,0,1-.5-.5v-2.5a.5.5,0,0,1,.5-.5h3.172l-1.5-1.5H155.5a2,2,0,0,0-2,2v2.5a2,2,0,0,0,2,2h12a2,2,0,0,0,2-2v-2.5A2,2,0,0,0,167.5,9.25ZM167,12.5a.75.75,0,1,0-.75.75A.75.75,0,0,0,167,12.5Zm-6.031-1.247a.674.674,0,0,0,.531.247.745.745,0,0,0,.53-.22l4.25-4.25A.75.75,0,0,0,165.22,5.97l-2.97,2.971V.5a.75.75,0,0,0-1.5,0V8.941l-3-2.972a.75.75,0,0,0-1.061,1.061Z",
    transform: "translate(-153.5 0.25)",
    fill: "#26b4d6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadDetail);
export default __webpack_public_path__ + "static/media/download-detail.3c3682d1.svg";
export { ForwardRef as ReactComponent };